<template>
  <div id="settings">
    <Topbar @action="fnAction"></Topbar>
    <v-container class="center" v-if="loaded">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <v-flex @click="show_basic = !show_basic" xs12 class="name">{{
                  $t("private_zone")
                }}</v-flex>

                <v-flex xs12 md12 class="item">
                  <v-switch
                    v-model="event['main_actions']"
                    :label="'params.settings.main_actions' | i18n"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md12 class="item">
                  <v-switch
                    v-if="!event.is_campus"
                    v-model="event['insurance']"
                    :label="'params.settings.insurance' | i18n"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md12 class="item">
                  <v-switch
                    v-if="!event.is_campus"
                    v-model="event['transfers']"
                    :label="'params.settings.transfers' | i18n"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md12 class="item">
                  <v-switch
                    v-if="!event.is_campus"
                    v-model="event['credentials']"
                    :label="'params.settings.credentials' | i18n"
                  ></v-switch>
                </v-flex>

                <!-- DEADLINES SECTION -->
                <v-flex xs12 class="name">{{ $t('deadlines') }}</v-flex>

                <template v-for="dl in localDeadlines">
                  <v-layout row wrap align-center :key="dl.id">
                    <!-- Step label -->
                    <v-flex xs12 sm5 md6 class="item">
                      <div class="subheading">{{ $t(dl.step) }}</div>
                    </v-flex>

                    <!-- Date picker: also wide enough to show full date -->
                    <v-flex xs12 sm7 md6 class="item">
                      <v-menu
                        v-model="deadlineMenus[dl.id]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="260px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="date-field"
                            v-on="on"
                            :value="displayDate(dl.limit_date)"
                            :label="$t('date_of_completition')"
                            prepend-icon="event"
                            readonly
                            clearable
                            hide-details
                            :placeholder="$t('choose_date')"
                            @click:clear="clearDeadline(dl.id)"
                          />
                        </template>

                        <v-date-picker
                          :value="dl.limit_date"
                          @input="onPickDeadline(dl.id, $event)"
                          scrollable
                        />
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </template>

                <template v-if="event.is_campus">
                  <v-flex @click="show_basic = !show_basic" xs12 class="name">{{
                    $t("inscriptions")
                  }}</v-flex>
                  <v-flex xs12 md12 class="item">
                    <v-text-field
                      label="Límit participants"
                      v-model="event['limit_participants']"
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Topbar from "@/components/ui/Topbar";

export default {
  name: "Settings",
  components: { Topbar },
  props: { page: String, action: String },
  data() {
    return {
      show_basic: true,
      loaded: false,
      valid: true,
      event: {},
      // deadlines UI state
      localDeadlines: [],           // [{ id, step, limit_date: 'YYYY-MM-DD' | null }]
      deadlineMenus: {}             // { [id]: boolean }
    };
  },
  computed: {
    maxDate () {
      // if you want to prevent future dates; set to null to allow any date
      const today = new Date().toISOString().slice(0,10);
      return today;
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created() {
    this.loadDataPage();
  },
  methods: {
    loadDataPage () {
      this.$store.commit("setTopbarActionsVisible", true);
      this.$store.commit("setMenuVisible", true);

      this.event = { ...this.$store.getters["events/getCurrentEvent"]() };
      // Initialize deadlines local copy
      this.localDeadlines = this.normalizeDeadlines(this.event.deadlines || []);
      this.ensureMenus(this.localDeadlines);

      this.$overlay.hide();
      this.loaded = true;
    },

    // --- DEADLINES helpers ---
    normalizeDeadlines(arr) {
      // Keep only the fields we need, normalize date to 'YYYY-MM-DD' or null
      if (!Array.isArray(arr)) return [];
      return arr.map(d => ({
        id: d.id,
        step: String(d.step),
        limit_date: d.limit_date ? String(d.limit_date).slice(0,10) : null
      }));
    },
    ensureMenus(rows) {
      (rows || []).forEach(d => {
        if (this.deadlineMenus[d.id] === undefined) {
          this.$set(this.deadlineMenus, d.id, false);
        }
      });
    },
    displayDate (iso) {
      if (!iso) return ''
      // Expecting YYYY-MM-DD; render DD/MM/YYYY
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso))
      if (!m) return String(iso)
      return `${m[3]}/${m[2]}/${m[1]}`
    },
    onPickDeadline (id, isoDate) {
      this.$set(this.deadlineMenus, id, false)
      this.localDeadlines = this.localDeadlines.map(d =>
        d.id === id ? { ...d, limit_date: isoDate } : d
      )
    },
    clearDeadline (id) {
      this.localDeadlines = this.localDeadlines.map(d =>
        d.id === id ? { ...d, limit_date: null } : d
      )
    },
    formatDateForField(d) {
      // Show empty string if null, otherwise keep YYYY-MM-DD or format to DD/MM/YYYY if you prefer
      return d || "";
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "save":
          this.fnSave(emit.params);
          break;
      }
    },

    fnSave() {
      let self = this;
      if (this.$refs.form.validate()) {
        this.$overlay.loading();
        let settings = {
          main_actions: this.event.main_actions ? 1 : 0,
          credentials: this.event.credentials ? 1 : 0,
          transfers: this.event.transfers ? 1 : 0,
          insurance: this.event.insurance ? 1 : 0,
          limit_participants: this.event.limit_participants
            ? this.event.limit_participants
            : 0,

          // 🔴 IMPORTANT: backend expects a JSON-decoded array in $_POST['deadlines'].
          // We send a JSON string here; your server code does json_decode($_POST['deadlines'], true)
          deadlines: JSON.stringify(
            this.localDeadlines.map(d => ({
              id: d.id,
              step: d.step,                 // include if backend wants to see it; safe to keep
              limit_date: d.limit_date      // 'YYYY-MM-DD' or null
            }))
          )
        };

        this.$store
          .dispatch("events/update_settings", settings)
          .then(response => {
            self.$overlay.hide();
            self.$popup.alert({
              message: "Les configuracions del esdeveniment s'han actualitzat",
              btnSuccess: i18n.t("accept")
            });
          });
      } else {
        this.$popup.alert({
          message: i18n.t("exists_error_on_form"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    formatDate() {
      this.match.parsedDate = moment(this.match.date).format("DD/MM/YYYY");
    }
  },
  filters: {
    checkParam(value) {
      return value != null ? value : "";
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.date-field .v-input__slot {
  min-width: 260px;  /* give the value room so it shows full date */
}
.subheading { line-height: 1.2; }
#settings {
  width: 100%;
  display: inline-block;
  height: 100%;
  overflow-y: auto;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .name {
      font-size: 22px;
      border-bottom: 2px solid;
      cursor: pointer;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      &.hidden {
        &::after {
          transform: rotate(180deg);
          transition-duration: 0.2s;
        }
      }
    }

    .clear {
    }

    .role {
      padding: 0;

      .container {
        margin: 0;
        width: 100%;

        .name {
          font-size: 18px;
          color: #685f5f;
        }
      }
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#acta {
        background-color: #ccc;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 20px;

        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .name {
          position: relative;

          .remove {
            width: fit-content;
            float: right;
          }

          .add {
            background-image: url(/img/add_b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: 15px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        .v-image {
          width: 50px;
        }

        label {
          text-transform: capitalize;
        }
        .v-input__prepend-inner {
          margin-top: 25px;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }
      }

      .v-menu__content {
        position: fixed !important;
      }
      .v-select {
        label {
          text-transform: capitalize;
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }

    img {
      width: 60px;
      max-width: 60px;
      line-height: 60px;
    }
    .label_image {
      line-height: 60px;
    }
  }
}
</style>
